var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAddressBook = function SvgIconAddressBook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.268,
    height: 24.307,
    viewBox: "0 0 21.268 24.307",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7,7.6a.572.572,0,0,0,.57-.57v-1.9a.572.572,0,0,0-.57-.57h-.949V2.279A2.28,2.28,0,0,0,17.47,0H2.279A2.28,2.28,0,0,0,0,2.279V22.028a2.28,2.28,0,0,0,2.279,2.279H17.47a2.28,2.28,0,0,0,2.279-2.279V19.749H20.7a.572.572,0,0,0,.57-.57v-1.9a.572.572,0,0,0-.57-.57h-.949V13.672H20.7a.572.572,0,0,0,.57-.57V11.2a.572.572,0,0,0-.57-.57h-.949V7.594H20.7ZM17.47,22.028H2.279V2.279H17.47Zm-7.6-9.875A3.038,3.038,0,1,0,6.836,9.115,3.041,3.041,0,0,0,9.875,12.153ZM5.621,18.23h8.507a1,1,0,0,0,1.063-.911v-.911A2.989,2.989,0,0,0,12,13.672a11.45,11.45,0,0,1-2.127.38,11.3,11.3,0,0,1-2.127-.38,2.989,2.989,0,0,0-3.19,2.734v.911a1,1,0,0,0,1.063.911Z",
    fill: "#f6c866"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAddressBook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-address-book.7455adb5.svg";
export { ForwardRef as ReactComponent };